export const orderConfirm = "/orders/confirm/:orderNumber";
export const internationalMenuRoute = "/international/menu/:countryName?";
export const prismicPages = "/:uid";
export const prismicStaticPages = "/staticPages/:uid";
export const press = "/press";
export const faqs = "/faqs";
export const contactUs = "/contact-us";
export const getAQuote = "/get-a-quote";
export const bookACall = "/book-a-call";
export const caseStudies = "/case-studies";
export const caseStudyPages = "/case-studies/:uid";
export const showChatbotWindow = "/showChatbotWindow";
export const stadiumBookACall = "/book-a-call/:uid";
